module.exports = __webpack_public_path__ + "static/media/pdfIcon.d9b2ac01.svg";